/* ══════════════════════════════════════════════════════════════════════
 * CALCULADORA DE FRETE NA PDP  —  VERSAO DE TESTE
 *
 * POR QUE O CODIGO E ASSIM (ler antes de mexer):
 *
 * O frete da loja e calculado em tempo real por transportadora (Frenet e
 * Hub de Frete), nao e tabela fixa. Quem sabe o valor e o Shopify, e o
 * unico endpoint publico que responde isso e
 * /cart/shipping_rates.json — que cota O CARRINHO.
 *
 * Testado em 01/10: carrinho vazio devolve {"shipping_rates":[]}. Ou seja,
 * nao da pra cotar um produto que nao esta no carrinho.
 *
 * Entao, para cotar o produto da PDP, este script:
 *   1. fotografa o carrinho   (/cart.js)
 *   2. adiciona 1 unidade     (/cart/add.js)
 *   3. cota                   (/cart/shipping_rates.json)
 *   4. DESFAZ, voltando o item a quantidade exata de antes (/cart/change.js)
 *
 * O passo 4 roda sempre, inclusive se a cotacao falhar, e tenta 3 vezes.
 * Mesmo assim: se o navegador morrer entre o 2 e o 4, sobra 1 unidade no
 * carrinho do cliente. E por isso que isto esta SO na pagina de teste.
 *
 * O jeito sem esse risco e a Storefront API (cria um carrinho isolado, nao
 * encosta no do cliente). Precisa de um token publico de storefront, que o
 * Jorge precisa autorizar/criar. Quando existir, trocar a funcao cotar().
 * ══════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var VIACEP = "https://viacep.com.br/ws/";
  var MOSTRAR = 3; /* quantas opcoes aparecem antes do "ver todas" */

  function digitos(s) { return String(s || "").replace(/\D/g, ""); }

  function mascara(s) {
    var d = digitos(s).slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + "-" + d.slice(5) : d;
  }

  function dinheiro(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return "";
    if (n <= 0) return "GRÁTIS";
    return "R$ " + n.toFixed(2).replace(".", ",");
  }

  function reais(centavos) {
    return "R$ " + (Number(centavos || 0) / 100).toFixed(2).replace(".", ",");
  }

  function json(url, opcoes) {
    return fetch(url, opcoes).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  /* ── o carrinho de cotacao ──────────────────────────────────────────
   * O Shopify so cota CARRINHO. A versao anterior punha o item no carrinho
   * do cliente, cotava e desfazia — e isso somava: quem ja tinha R$127 la
   * via o frete de R$254 e a caixa dizia GRATIS num item de R$127.
   *
   * Agora nao encostamos no carrinho dele. O carrinho e identificado pelo
   * cookie "cart" (nao e httpOnly, da pra ler e escrever). Entao:
   *
   *   1. guarda o token do cliente        (T1)
   *   2. aponta o cookie pro carrinho de cotacao, so nosso
   *   3. esvazia, poe SO este item, cota
   *   4. devolve o cookie pro T1
   *
   * O carrinho do cliente segue intacto no servidor o tempo todo: nenhum
   * add, nenhum change. A cotacao e do produto sozinho, sempre igual,
   * independente do que ele ja tenha.
   *
   * A janela de risco mudou de "sobra um item" para "o cookie fica apontado
   * pro carrinho errado". Por isso o T1 vai pro localStorage ANTES da troca
   * e e devolvido no proximo carregamento se algo morrer no meio.
   */
  var BILHETE  = "fm_fretep_carrinho";   /* token do cliente, enquanto trocamos */
  var RASCUNHO = "fm_fretep_cotador";    /* token do carrinho de cotacao, reaproveitado */

  function lerCookie() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? m[1] : "";
  }

  function porCookie(valor) {
    try {
      document.cookie = "cart=" + (valor || "") + "; path=/; samesite=lax" +
        (valor ? "; max-age=1209600" : "; max-age=0");
    } catch (e) {}
  }

  function guardar(chave, valor) { try { localStorage.setItem(chave, valor); } catch (e) {} }
  function pegar(chave)          { try { return localStorage.getItem(chave) || ""; } catch (e) { return ""; } }
  function apagar(chave)         { try { localStorage.removeItem(chave); } catch (e) {} }

  /* rede de seguranca: se o navegador morreu no meio da troca, o cookie
     ficou apontando pro carrinho de cotacao. Devolve o do cliente. */
  function cobrarBilhete() {
    var T1 = pegar(BILHETE);
    if (!T1) return;
    if (lerCookie() !== T1) porCookie(T1);
    apagar(BILHETE);
  }

  function cotar(idVariante, cep) {
    var uf, cidade;
    return json(VIACEP + cep + "/json/")
      .then(function (j) {
        if (!j || j.erro || !j.uf) throw new Error("cep");
        uf = j.uf;
        cidade = j.localidade || "";
        return cotarIsolado(idVariante, uf, cep);
      })
      .then(function (r) {
        return {
          uf: uf, cidade: cidade, opcoes: r.opcoes,
          precoItem: r.precoItem, totalCarrinho: r.totalCarrinho
        };
      });
  }

  function cotarIsolado(idVariante, uf, cep) {
    var precoItem = 0;
    var totalCarrinho = 0;      /* o carrinho DELE, lido antes de trocar nada */
    var T1 = lerCookie();
    guardar(BILHETE, T1);

    var rascunho = pegar(RASCUNHO);
    if (rascunho === T1) rascunho = "";     /* nunca cotar no carrinho dele */
    function entrarNoRascunho() { porCookie(rascunho); }

    /* Se o cliente sair da pagina no meio da cotacao, o cookie ficaria
       apontando pro carrinho de cotacao e o carrinho dele pareceria vazio.
       Escrever cookie e SINCRONO, entao da pra devolver no pagehide — que e
       justamente o unico lugar onde isso ainda funciona de forma confiavel. */
    function naSaida() { if (T1 && lerCookie() !== T1) porCookie(T1); }
    window.addEventListener("pagehide", naSaida);
    window.addEventListener("beforeunload", naSaida);

    function devolver() {
      guardar(RASCUNHO, lerCookie());       /* reaproveita na proxima cotacao */
      porCookie(T1);
      apagar(BILHETE);
      window.removeEventListener("pagehide", naSaida);
      window.removeEventListener("beforeunload", naSaida);
    }

    /* So limpa se o carrinho de rascunho JA existe. Sem cookie nenhum, o
       add.js ja cria um carrinho novo com o item sozinho — e o clear.js sem
       corpo devolve 411 Length Required (conferido em 01/10), o que quebraria
       a cotacao inteira na primeira vez de cada cliente. */
    function limpar() {
      return rascunho
        ? json("/cart/clear.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: "{}"
          })
        : Promise.resolve();
    }

    return json("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (meu) { totalCarrinho = (meu && meu.total_price) || 0; },
            function ()    { totalCarrinho = 0; })
      .then(function () { entrarNoRascunho(); return limpar(); })
      .then(function () {
        return json("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(idVariante), quantity: 1 }] })
        });
      })
      .then(function (res) {
        var it = (res && res.items && res.items[0]) || res;
        precoItem = (it && (it.final_price != null ? it.final_price : it.price)) || 0;
        var url = "/cart/shipping_rates.json" +
          "?shipping_address%5Bcountry%5D=Brazil" +
          "&shipping_address%5Bprovince%5D=" + encodeURIComponent(uf) +
          "&shipping_address%5Bzip%5D=" + encodeURIComponent(cep);
        return json(url, { headers: { Accept: "application/json" } });
      })
      .then(
        function (d) {
          devolver();
          return {
            opcoes: (d && d.shipping_rates) || [],
            precoItem: precoItem,
            totalCarrinho: totalCarrinho
          };
        },
        function (e) { devolver(); throw e; }
      );
  }

  /* ── desenho do resultado ───────────────────────────────────────────
   * O Shopify so cota CARRINHO, entao a cotacao e sempre "o que ja esta no
   * carrinho + este item". O frete gratis sai do subtotal passar de R$ 200
   * (conferido em 01/10: 197 cobra, 214 e gratis).
   *
   * Isso enganava: quem ja tinha R$ 127 no carrinho abria um item de R$ 97,
   * via GRATIS, nao levava o item, e no pagamento pagava frete. Por isso
   * GRATIS nunca aparece sozinho — vem sempre com o porque, dizendo o total
   * COM ESTE ITEM. E quando falta pouco, a caixa diz quanto falta.
   */
  function desenhar(saida, dados) {
    var ops = dados.opcoes.slice().sort(function (a, b) {
      return parseFloat(a.price) - parseFloat(b.price);
    });

    if (!ops.length) {
      saida.innerHTML = '<p class="fm-fretep__erro">Não encontramos entrega para esse CEP. ' +
        'Fale com a gente que a gente dá um jeito.</p>';
      saida.hidden = false;
      return;
    }

    var limite = dados.limite || 20000;
    var temGratis = parseFloat(ops[0].price) <= 0;

    var local = dados.cidade ? dados.cidade + "/" + dados.uf : dados.uf;

    var html = '<p class="fm-fretep__local">' + local + '</p><ul class="fm-fretep__lista">';

    ops.forEach(function (o, i) {
      var gratis = parseFloat(o.price) <= 0;
      html += '<li class="fm-fretep__op' + (i >= MOSTRAR ? " is-extra" : "") + '" ' +
        (i >= MOSTRAR ? "hidden" : "") + '>' +
        '<div class="fm-fretep__op-txt">' +
          '<span class="fm-fretep__op-nome">' + o.name + "</span>" +
          (o.description ? '<span class="fm-fretep__op-prazo">' + o.description + "</span>" : "") +
        "</div>" +
        '<span class="fm-fretep__op-preco' + (gratis ? " is-gratis" : "") + '">' +
          dinheiro(o.price) + "</span></li>";
    });
    html += "</ul>";

    if (ops.length > MOSTRAR) {
      html += '<button type="button" class="fm-fretep__mais" data-fm-fretep-mais>' +
        "ver mais " + (ops.length - MOSTRAR) + " opções</button>";
    }

    /* O PRECO acima e sempre do item sozinho — e o que nao pode mentir.
     * A linha abaixo fala do pedido, e cada frase diz a sua condicao:
     *
     *   carrinho >= 200            -> ja e fato, ele tem frete gratis
     *   carrinho + item >= 200     -> so levando ESTE item (a frase diz isso)
     *   nenhum dos dois            -> quanto falta
     *
     * O engano antigo era afirmar GRATIS sem dizer de onde vinha.
     */
    var carrinho = dados.totalCarrinho || 0;
    var comItem  = carrinho + (dados.precoItem || 0);

    if (temGratis) {
      html += '<p class="fm-fretep__gratis">Este produto já tem <b>frete grátis</b> ' +
        '(pedidos acima de ' + reais(limite) + ').</p>';
    } else if (carrinho >= limite) {
      html += '<p class="fm-fretep__gratis">Você já tem <b>frete grátis</b> ' +
        '— seu carrinho está em ' + reais(carrinho) + '.</p>';
    } else if (comItem >= limite) {
      html += '<p class="fm-fretep__gratis">Levando este item, seu pedido passa de ' +
        reais(limite) + ' e o <b>frete sai grátis</b>.</p>';
    } else if (comItem > 0) {
      html += '<p class="fm-fretep__falta">Faltam <b>' + reais(limite - comItem) +
        '</b> no pedido para o frete sair grátis.</p>';
    }

    saida.innerHTML = html;
    saida.hidden = false;
  }

  /* ── de qual variante estamos falando? ─────────────────────────────
   * A calculadora roda em PDPs diferentes (multi, mono, acessorios, kits) e
   * cada secao tem o seu proprio input de variante. Procura do mais perto
   * pro mais longe, e o ultimo recurso fica DENTRO da secao — senao pegaria
   * o formulario de um card de recomendacao no rodape.
   */
  function idDaVariante(raiz) {
    var escopo = (raiz.closest && raiz.closest(".shopify-section")) || document;

    var form = raiz.closest && raiz.closest('form[action*="/cart/add"]');
    if (form) {
      var dentro = form.querySelector('[name="id"]');
      if (dentro && dentro.value) return dentro.value;
    }

    var fm = document.getElementById("fm-v2-variant-id");   /* PDP das linhas */
    if (fm && fm.value) return fm.value;

    var naSecao = escopo.querySelector('form[action*="/cart/add"] [name="id"]');
    if (naSecao && naSecao.value) return naSecao.value;

    return "";
  }

  /* ── ligacao com a tela: DELEGACAO no document ──────────────────────
   * Nada de listener preso ao elemento.
   *
   * Por que: a PDP troca o bloco inteiro ao mudar de camuflagem, e apps
   * podem re-renderizar a secao a qualquer momento. Um listener preso ao
   * botao morre calado nessas horas — a caixa continua na tela e o
   * CALCULAR vira enfeite.
   *
   * Isso ACONTECEU no primeiro teste no ar (01/10): a caixa aparecia,
   * o botao nao fazia nada, e na rodada seguinte o problema trocou de
   * lado (ligou no live e falhou no rascunho). Era corrida, nao ambiente.
   * E o mesmo motivo pelo qual a calculadora do carrinho ja escutava no
   * document.
   */
  var emVoo = [];

  function raizDe(el) {
    return el && el.closest ? el.closest("[data-fm-fretep]") : null;
  }

  function calcular(raiz) {
    if (!raiz || emVoo.indexOf(raiz) !== -1) return;

    var campo = raiz.querySelector("[data-fm-fretep-cep]");
    var botao = raiz.querySelector("[data-fm-fretep-btn]");
    var saida = raiz.querySelector("[data-fm-fretep-out]");
    if (!campo || !botao || !saida) return;

    function mostrar(html) { saida.innerHTML = html; saida.hidden = false; }

    var cep = digitos(campo.value);
    if (cep.length !== 8) {
      mostrar('<p class="fm-fretep__erro">Digite os 8 números do CEP.</p>');
      campo.focus();
      return;
    }

    var idVariante = idDaVariante(raiz);
    if (!idVariante) {
      var aviso = raiz.getAttribute("data-fm-fretep-aviso") || "Selecione o produto primeiro.";
      mostrar('<p class="fm-fretep__erro">' + aviso + "</p>");
      return;
    }

    /* sem cache de proposito: a cotacao depende do carrinho, e o carrinho
       muda. Guardar por variante+CEP devolveria um valor velho depois que o
       cliente adicionasse algo — justamente o engano que estamos corrigindo. */
    emVoo.push(raiz);
    botao.disabled = true;
    mostrar('<p class="fm-fretep__carregando">Calculando…</p>');

    cotar(idVariante, cep)
      .then(function (dados) {
        dados.limite = parseInt(raiz.getAttribute("data-fm-fretep-limite") || "20000", 10) || 20000;
        desenhar(saida, dados);
      })
      ["catch"](function (erro) {
        mostrar('<p class="fm-fretep__erro">' +
          (String(erro && erro.message) === "cep"
            ? "CEP não encontrado. Confere pra mim?"
            : "Não deu pra calcular agora. Tenta de novo em instantes.") + "</p>");
      })
      .then(function () {
        var i = emVoo.indexOf(raiz);
        if (i !== -1) emVoo.splice(i, 1);
        botao.disabled = false;
      });
  }

  function instalar() {
    if (window.__fmFretepInstalado) return;
    window.__fmFretepInstalado = true;

    document.addEventListener("input", function (e) {
      var campo = e.target && e.target.closest && e.target.closest("[data-fm-fretep-cep]");
      if (campo) campo.value = mascara(campo.value);
    });

    /* o campo mora DENTRO do <form> do produto: Enter aqui enviaria o
       formulario e jogaria o produto no carrinho. nao pode. */
    document.addEventListener("keydown", function (e) {
      var campo = e.target && e.target.closest && e.target.closest("[data-fm-fretep-cep]");
      if (!campo) return;
      if (e.key === "Enter" || e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        calcular(raizDe(campo));
      }
    });

    document.addEventListener("click", function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;

      var botao = alvo.closest("[data-fm-fretep-btn]");
      if (botao) { calcular(raizDe(botao)); return; }

      var mais = alvo.closest("[data-fm-fretep-mais]");
      if (mais) {
        var raiz = raizDe(mais);
        if (!raiz) return;
        Array.prototype.forEach.call(raiz.querySelectorAll(".is-extra"), function (li) {
          li.hidden = false;
        });
        mais.remove();
      }
    });

    cobrarBilhete();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", instalar);
  } else {
    instalar();
  }
})();
